(function () {
    'use strict';

    angular
        .module('blocks.smart')
        .directive('smartSelect', smartSelect);

    /* @ngInject */
    function smartSelect() {
        // allows us to have a select filter on smart tables.
        // Usage:
        //  <smart-select collection="vm.someCollection"></smart-select>
        // Creates:
        //  <smart-select collection="vm.someCollection">
        //  <select><select>
        //  </smart-select>
        var directive = {
            link: link,
            require: '^stTable',
            scope: {
                collection: '=',
                predicate: '@',
                predicateExpression: '='
            },
            template: '' +
                '<select class="form-control"  ng-model="selectedOption" ng-change="optionChanged(selectedOption)"' +
                '   ng-options="option.name for option in distinctItems track by option.value">' +
                '</select>'
        };
        return directive;

        function link(scope, element, attr, table) {
            scope.$watch('collection', function (newValue) {
                if (newValue) {
                    scope.distinctItems = [{ value: 0, name: 'All' }];
                    var temp = scope.distinctItems.concat(uniqueBy(scope.collection, function (x) { return x.value; }));
                    temp.sort();
                    scope.distinctItems = temp;
                    scope.selectedOption = scope.distinctItems[0];
                    scope.optionChanged(scope.selectedOption);
                }
            }, true);

            scope.optionChanged = function (selectedOption) {
                var predicate = getPredicate();
                table.search(selectedOption.value, predicate);
            };

            scope.$watch(
               function watch(scope) {
                   return (table.tableState().search.predicateObject[scope.predicate]);
               }, function (newValue) {
                   if (typeof newValue === 'undefined') {
                       scope.selectedOption = scope.distinctItems[0];
                   }
               },
               true);

            function getPredicate() {
                var predicate = scope.predicate;
                if (!predicate && scope.predicateExpression) {
                    predicate = scope.predicateExpression;
                }
                return predicate;
            }
        }

        function uniqueBy(arr, fn) {
            var unique = {};
            var distinct = [];
            arr.forEach(function (x) {
                var key = fn(x);
                if (!unique[x]) {
                    distinct.push(x);
                    unique[key] = true;
                }
            });
            return distinct;
        }
    }
})();

